module.exports = __webpack_public_path__ + "static/media/completed_dot.ff81f439.svg";